
export const dateTime = 'YYYY-MM-DD HH:mm:ss'
export const hourMinuteSecond = 'HH:mm:ss'
export const hourMinute = 'HH:mm'
export const monthDayHourMinute = 'MM/DD HH:mm'
export const monthDayHourMinutehourMinuteSecond = 'MM/DD HH:mm:ss'
export const monthDay = 'MM/DD'
